"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const carabiners_1 = require("@clearsummit/carabiners");
const core_1 = require("@emotion/core");
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const index_1 = require("../../constants/index");
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
class ButtonComponent extends React.Component {
    constructor() {
        super(...arguments);
        this.getButtonProps = () => {
            const btnProps = Object.assign({}, this.props);
            // Delete unused non DOM props
            delete btnProps.variant;
            delete btnProps.toggleIcon;
            return btnProps;
        };
        this.renderIcon = () => {
            const { imgUrls, isFilter, filterCount } = this.props;
            if (isFilter && filterCount) {
                return null;
            }
            return imgUrls ? core_1.jsx("span", { className: "icon" }) : null;
        };
        this.renderToggle = () => {
            const { toggleIcon, isToggle, disabled, variant } = this.props;
            if (variant === 'ghost') {
                toggleIcon.default = index_1.Images.angleDownGreen;
            }
            return isToggle ? (core_1.jsx("div", { css: styles_1.default.toggle(toggleIcon, variant, disabled) },
                core_1.jsx("div", { className: "toggle-icon" }))) : null;
        };
        this.renderFilterCount = () => {
            const { isFilter, filterCount } = this.props;
            return isFilter && filterCount ? core_1.jsx("div", { className: styles_scss_1.default.filterCount }, filterCount) : null;
        };
    }
    render() {
        const _a = this.getButtonProps(), { ariaLabel, children, onClick, title, className, type, innerRef } = _a, rest = __rest(_a, ["ariaLabel", "children", "onClick", "title", "className", "type", "innerRef"]);
        if (typeof onClick === 'string') {
            return (core_1.jsx(react_router_dom_1.Link, Object.assign({ to: onClick, "aria-label": ariaLabel, className: carabiners_1.joinStr(styles_scss_1.default.button, styles_scss_1.default.link, className) }, rest),
                this.renderIcon(),
                title));
        }
        delete rest.isToggle;
        delete rest.imgUrls;
        delete rest.isFilter;
        delete rest.filterCount;
        return (core_1.jsx("button", Object.assign({ ref: innerRef, type: type, onClick: onClick, "aria-label": ariaLabel, className: carabiners_1.joinStr(styles_scss_1.default.button, className), css: styles_1.default.button(this.props) }, rest),
            this.renderIcon(),
            this.renderFilterCount(),
            title,
            children,
            this.renderToggle()));
    }
}
ButtonComponent.defaultProps = {
    innerRef: undefined,
    imgUrls: null,
    variant: 'primary',
    isToggle: false,
    isFilter: false,
    filterCount: null,
    title: '',
    className: '',
    onClick: undefined,
    type: 'button',
    disabled: false,
    children: null,
    toggleIcon: { default: index_1.Images.angleDown, disabled: index_1.Images.angleDownDisabled },
};
exports.default = React.forwardRef((props, ref) => (core_1.jsx(ButtonComponent, Object.assign({ innerRef: ref }, props))));
